module.exports = __webpack_public_path__ + "img/man.0c2d8310.png";